import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4caab063&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4caab063&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caab063",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4caab063')) {
      api.createRecord('4caab063', component.options)
    } else {
      api.reload('4caab063', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4caab063&scoped=true", function () {
      api.rerender('4caab063', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/history/views/index.vue"
export default component.exports